import React from "react"
import { Popover } from "antd"

export default {
    tableStatus(audit, time, publish_name) {
        if (audit === '0') {
            return (<span>{publish_name}</span>)
        } else {
            return (
                <span>
                    <div>
                        <span>{publish_name}</span>
                    </div>
                    <div>{time}</div>
                </span>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/routes/sign/common.js